import api from './api';

const inquiryService = {
  // Create a new inquiry
  createInquiry: async (data) => {
    const response = await api.post('/auth/inquiries/', data);
    return response.data;
  },

  // Get user's inquiries
  getMyInquiries: async (params = {}) => {
    const response = await api.get('/auth/inquiries/my/', { params });
    return response.data;
  },

  // Get a specific inquiry
  getInquiry: async (id) => {
    const response = await api.get(`/auth/inquiries/${id}/`);
    return response.data;
  },

  // Admin: Get all inquiries
  getAdminInquiries: async (params = {}) => {
    const response = await api.get('/auth/admin/inquiries/', { params });
    return response.data;
  },

  // Admin: Update/respond to inquiry
  updateInquiry: async (id, data) => {
    const response = await api.patch(`/auth/admin/inquiries/${id}/`, data);
    return response.data;
  },
};

export default inquiryService;
